
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M0 12.2L2.9 10l1.5 1.1 5.9-4.4 2.2 1.7L14 7.3v4.9zM2.6 2.8c1.1 0 2 .8 2 1.8s-.9 1.8-2 1.8-2-.8-2-1.8.9-1.8 2-1.8"}})])
          )
        }
      }
    